module.exports = __webpack_public_path__ + "static/media/solucionIntegral.17d9cdc6.png";